import { render, staticRenderFns } from "./EmailTemplateListItem.vue?vue&type=template&id=27581f61"
import script from "./EmailTemplateListItem.vue?vue&type=script&lang=js"
export * from "./EmailTemplateListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports